import { useContext, useEffect, useState } from 'react'
import { HeadFC, Link, PageProps } from 'gatsby'
import queryString from 'query-string'

import Loading from '@atoms/Loading'
import Button from '@atoms/Button'
import Modal from '@molecules/Modal'
import Pager from '@src/components/molecules/Pager'
import SaveIcon from '@icons/Save'
import Layout from '@src/components/Layout'
import Seo from '@src/components/Seo'
import ArticleList from '@src/components/ArticleList'
import MypageWrapper from '@src/components/MypageWrapper'
import { StoreContext } from '@models/Store'
import { Article, useAllArticles, useArticle } from '@models/Article'
import { getBookmark } from '@models/Bookmark'
import { checkNumber } from '@models/Util'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

const PAGE_LIMIT = 12

const SavePage = ({ location }: PageProps) => {
  const { entity, action } = useContext(StoreContext)
  const { user } = entity
  const { t } = useTranslation()

  const pageParam = checkNumber(queryString.parse(location.search).page, 1)
  const [page, setPage] = useState(1)

  const [total, setTotal] = useState(0)
  const [bookmarkArticle, setBookmarkArticle] = useState<Article[]>([])
  const { getArticles } = useArticle()
  const allArticles = useAllArticles()
  const [loading, setLoading] = useState(true)

  const notSignIn = user?.isSignIn !== true
  const articles = notSignIn ? bookmarkArticle.slice(0, 3) : bookmarkArticle

  useEffect(() => {
    if (user === undefined) {
      return
    }

    setLoading(true)
    getBookmark(user.isSignIn, page, PAGE_LIMIT)
      .then(({ ids, total }) => {
        setTotal(total)
        setBookmarkArticle(getArticles(ids))
        setLoading(false)
      })
      .catch(error => {
        action.addToasts(t('mypage.failGetSave'))
      })
  }, [user, page])

  useEffect(() => {
    if (pageParam === undefined) {
      return
    }

    setPage(pageParam)
  }, [pageParam])

  return (
    <Layout>
      <MypageWrapper type="save">
        <div className={style.top}>
          <h2>
            <SaveIcon />
            {t('mypage.save')}
          </h2>
          {notSignIn && (
            <div className={style.notice}>{t('mypage.deleteData')}</div>
          )}
        </div>

        <div className={style.list}>
          {loading ? (
            <div className={style.loadingContainer}>
              <Loading />
            </div>
          ) : (
            <>
              {bookmarkArticle.length === 0 ? (
                <div className={style.noArticle}>{t('mypage.noSave')}</div>
              ) : (
                <ArticleList
                  articles={articles}
                  displaysCategory
                  gtmClickType="save"
                />
              )}
              {notSignIn && (
                <div className={style.more}>
                  <div className={style.blur}>
                    <ArticleList
                      articles={allArticles.slice(0, 3)}
                      displaysCategory
                      gtmClickType="save"
                    />
                  </div>
                  <div className={style.modalContainer}>
                    <Modal>
                      <div className={style.contents}>
                        <div className={style.label}>
                          {t('mypage.beRegistration')}
                        </div>
                        {t('mypage.more')}
                        <Link to="/signup">
                          <Button design="white">
                            {t('mypage.registration')} / {t('mypage.login')}
                          </Button>
                        </Link>
                      </div>
                    </Modal>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {!notSignIn && bookmarkArticle.length > 0 && (
          <Pager totalPage={Math.ceil(total / PAGE_LIMIT)} page={page} />
        )}
      </MypageWrapper>
    </Layout>
  )
}

export const Head: HeadFC = ({ location }) => (
  <Seo pathName={location.pathname} title="History" />
)

export default SavePage
